import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const fetcHomehData = createAsyncThunk(
  "data/fetcHomehData",
  async () => {
    const response = await axios.get(`${process.env.REACT_APP_BASE_URL}/home`);
    return response.data;
  }
);

const homeSlice = createSlice({
  name: "home",
  initialState: {
    data: [],
    status: "idle",
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetcHomehData.pending, (state) => {
        state.status = "loading";
      })
      .addCase(fetcHomehData.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.data = action.payload;
      })
      .addCase(fetcHomehData.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.error.message;
      });
  },
});

export default homeSlice.reducer;
